export enum SignUpSource {
  Intro = 'intro',
  Billboard = 'billboard',
  ContactInformation = 'contact-information',
}
